import { useEffect, useState } from "react";
import { api } from "../api";

const LABELS = {
  total_visitors: "Toplam Ziyaretçi",
  appointments_pending: "Bekleyen Randevu",
  appointments_total: "Toplam Randevu",
  chat_sessions: "AI Sohbeti",
  contacts: "İletişim Mesajı",
  blog_posts: "Blog Yazısı",
  gallery_images: "Galeri Görseli",
};

const PAGE_NAMES = {
  "/": "Ana Sayfa", "/odalar": "Odalar", "/hizmetler": "İmkanlar", "/videolar": "Videolar",
  "/galeri": "Galeri", "/konum": "Konum", "/hakkimizda": "Hakkımızda", "/iletisim": "İletişim", "/blog": "Blog",
};

const fmtTime = (iso) => new Date(iso).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
const fmtDate = (iso) => new Date(iso).toLocaleString("tr-TR", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

const DashboardTab = () => {
  const [stats, setStats] = useState(null);
  const [visitors, setVisitors] = useState([]);
  const [chats, setChats] = useState([]);

  useEffect(() => {
    const load = () => {
      api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
      api.get("/admin/visitors").then(({ data }) => setVisitors(data.visitors)).catch(() => {});
      api.get("/admin/chat-logs").then(({ data }) => setChats(data.logs.slice(0, 5))).catch(() => {});
    };
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);

  if (!stats) return <p className="text-sm text-ink-500">Yükleniyor...</p>;

  return (
    <div data-testid="dashboard-tab">
      <h1 className="text-2xl font-bold tracking-tight text-ink-900 sm:text-3xl">Genel Bakış</h1>
      <p className="mt-2 text-sm text-ink-500">Site anlık durumu — 15 saniyede bir güncellenir.</p>

      <div className="mt-8 border border-line bg-ink-900 p-8 sm:p-10" data-testid="active-visitors-card">
        <p className="label flex items-center gap-2 text-cream-50/50">
          <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-cream-50" />
          Şu an sitede
        </p>
        <p className="mt-3 text-5xl font-bold tracking-tight text-cream-50 sm:text-6xl" data-testid="active-visitors-count">
          {stats.active_visitors}
        </p>
        <p className="mt-2 text-xs uppercase tracking-[0.18em] text-cream-50/50">aktif ziyaretçi</p>
      </div>

      {visitors.length > 0 && (
        <div className="mt-4 border border-line bg-white" data-testid="live-visitors-list">
          <p className="border-b border-line px-5 py-3.5 text-[11px] font-bold uppercase tracking-[0.18em] text-ink-400">
            Şu an gezinenler
          </p>
          {visitors.map((v, i) => (
            <div key={v.session_id} className="flex items-center justify-between px-5 py-3 text-sm" data-testid={`visitor-${i}`}>
              <span className="flex items-center gap-2.5 font-medium text-ink-800">
                <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-ink-900" />
                {PAGE_NAMES[v.path] || v.path}
                {v.path.startsWith("/odalar/") && <span className="text-xs text-ink-400">({v.path.replace("/odalar/", "")})</span>}
              </span>
              <span className="text-xs text-ink-400">{fmtTime(v.last_seen)}</span>
            </div>
          ))}
        </div>
      )}

      <div className="mt-6 grid grid-cols-2 gap-px border border-line bg-line sm:grid-cols-3 lg:grid-cols-4">
        {Object.entries(LABELS).map(([k, label]) => (
          <div key={k} className="card-lift bg-white p-6" data-testid={`stat-${k}`}>
            <p className="text-3xl font-bold tracking-tight text-ink-900">{stats[k]}</p>
            <p className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-400">{label}</p>
          </div>
        ))}
      </div>

      <div className="mt-10" data-testid="recent-chats">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold tracking-tight text-ink-900">Son AI Sohbetleri</h2>
        </div>
        <div className="mt-4 space-y-px border border-line bg-line">
          {chats.length === 0 && (
            <div className="bg-white p-8 text-center text-sm text-ink-400">Henüz sohbet yok.</div>
          )}
          {chats.map((c, i) => {
            const firstUser = c.messages.filter((m) => m.role === "user").pop();
            return (
            <div key={i} className="card-lift bg-white p-5" data-testid={`recent-chat-${i}`}>
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <p className="text-sm font-semibold text-ink-900">{firstUser ? firstUser.content : "—"}</p>
                  <p className="text-xs text-ink-400">{fmtDate(c.created_at)}</p>
                </div>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-ink-500">
                  <span className="font-semibold text-ink-800">Asistan: </span>
                  {c.reply.replace("[WHATSAPP]", "").trim()}
                </p>
              </div>
            );
          })}
        </div>
        <p className="mt-3 text-xs text-ink-400">Tüm sohbetler için soldaki "AI Sohbetleri" sekmesine gidin.</p>
      </div>
    </div>
  );
};

export default DashboardTab;
